import { apiReq } from "./_req";
import type { QuickSearchResponse } from "@backend-ctrl/search.controller";
import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { CacheKeyTypes } from "../cache";

interface QuickSearchParams {
  q: string;
}
async function quickSearch(params: QuickSearchParams) {
  const { data } = await apiReq.get<QuickSearchResponse>(`/search`, { params });
  return data;
}

export const useQuickSearch = (params: QuickSearchParams, opts?: UseQueryOptions<QuickSearchResponse, Error>) => {
  const queryKey: QueryKey = [CacheKeyTypes.QuickSearchResults, params];
  return useQuery<QuickSearchResponse, Error>(queryKey, () => quickSearch(params), {
    cacheTime: 1000 * 10,
    staleTime: 1000 * 10,
    // keepPreviousData: true,
    retry: false,
    ...opts,
  });
};

// not really needed cuz handled at backend
// const hits: Record<string, number | undefined> = {};
export const sendExternalHit = (href: string) => {
  // const last = hits[href];
  // const now = Date.now();
  // if (last && now - last < 600000) return;
  // hits[href] = now;
  apiReq.post("/search/external-hit", { href }).catch(() => {});
};
